"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMemoCompare = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * This hook is similar to useMemo, but instead of passing an array of dependencies we pass a custom compare function that
 * receives the previous and new value. The compare function can then compare nested properties, call object methods, or
 * anything else to determine equality. If the compare function returns true then the hook returns the old object reference.
 * https://usehooks.com/useMemoCompare/
 */
var useMemoCompare = function useMemoCompare(next, compare) {
  // Ref for storing previous value
  var previousRef = _react["default"].useRef();

  var previous = previousRef.current; // Pass previous and next value to compare function
  // to determine whether to consider them equal.

  var isEqual = compare(previous, next); // If not equal update previousRef to next value.
  // We only update if not equal so that this hook continues to return
  // the same old value if compare keeps returning true.

  _react["default"].useEffect(function () {
    if (!isEqual) {
      previousRef.current = next;
    }
  }); // Finally, if equal then return the previous value


  return isEqual ? previous : next;
};

exports.useMemoCompare = useMemoCompare;